import React from 'react';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';

import { AppState } from 'services/types';
import { makeSelectUsersMePersonValue } from 'services/usersMe/selectors';

type ChildrenFunction = (values: any) => React.ReactElement;

interface OwnProps {
    children: React.ReactElement | ChildrenFunction;
}

interface ConnectedProps {
    userPersonId: number;
}

type Props = OwnProps & ConnectedProps;

export class UserPersonIdComponent extends React.PureComponent<Props> {
    render(): React.ReactElement {
        const { userPersonId, children } = this.props;

        if (typeof children === 'function') {
            return children(userPersonId);
        }

        // @ts-ignore
        return React.cloneElement(children, { userPersonId });
    }
}

const mapStateToProps = createStructuredSelector<
    AppState,
    OwnProps,
    ConnectedProps
>({
    userPersonId: makeSelectUsersMePersonValue('id')
});

export default connect(mapStateToProps)(UserPersonIdComponent);
